const Input = ({
    type,
    name,
    placeholder
}) => {
  return (
    <input
      type={type}
      name={name}
      autoComplete={name}
      placeholder={placeholder}
      required
      className="relative w-full border border-olive text-body2Mobile md:text-body2Desktop text-olive placeholder:text-olive placeholder:opacity-50 outline-none font-chivoMono px-[13px] py-[15px] lg:p-smallDesktop"
    />
  )
}

export default Input